(function () {
  'use strict';

  function revealAll() {
    var all = document.querySelectorAll('#MainContent > .shopify-section');
    for (var i = 0; i < all.length; i++) all[i].classList.add('is-revealed');
  }

  // The inline head script set a watchdog that reveals everything if this file
  // never loads. Claim it now — if our setup below errors, the catch falls back
  // to revealAll() so content never stays hidden.
  if (window.__gcbRevealWatchdog) {
    clearTimeout(window.__gcbRevealWatchdog);
    window.__gcbRevealWatchdog = null;
  }

  try {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));

    if (prefersReducedMotion || sections.length === 0) {
      revealAll();
      return;
    }

    // Skip the first section (hero) — it gets its own entrance in a later phase
    var targets = sections.slice(1);
    if (targets.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (s) { s.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    });

    targets.forEach(function (s) { observer.observe(s); });
  } catch (e) {
    revealAll();
  }
})();
